import { coordinatesToGisCoordinates } from '@curbnturf/helpers';
import { IBoondock, ISearchableBoondocking } from '../interfaces';
import { AmenityList } from './amenity-list';
import { Boondock } from './boondock';
import { CoordinateGis } from './coordinates-gis';
import { Photo } from './photo';
import { RoadRestriction } from './searchable-listing';

export class SearchableBoondocking implements ISearchableBoondocking {
  id: number;

  // These coordinates should have reduced accuracy to so the listing data can be public
  coordinates: CoordinateGis;
  name: string;
  description: string;

  city?: string;
  state?: string;

  maxLengthOfStayInDays?: number;
  photos?: Photo[];
  maxHeight?: number; // ft
  maxWidth?: number; // ft
  maxLength?: number; // ft

  roadRestrictions: RoadRestriction[];

  amenities: AmenityList;

  rating: number;
  ratingCount: number;

  static fromBoondock(startingBoondock: IBoondock | Boondock): SearchableBoondocking | undefined {
    const boondock = new Boondock(startingBoondock);

    if (boondock.deleted || !boondock.available || !boondock.id || !boondock.coordinates?.lat || !boondock.coordinates?.lon) {
      return;
    }

    return new SearchableBoondocking({
      id: boondock.id,
      coordinates: coordinatesToGisCoordinates(boondock.coordinates),
      name: boondock.name || '',
      description: boondock.description || '',
      city: boondock.address?.city,
      state: boondock.address?.state,
      maxLengthOfStayInDays: boondock.maxLengthOfStayInDays,
      photos: boondock.photos?.map((photo) => new Photo(photo)),
      maxHeight: boondock.maxHeight,
      maxWidth: boondock.maxWidth,
      maxLength: boondock.maxLength,
      roadRestrictions: boondock.accessRoutes?.map((route) => ({
          maxHeight: route.maxHeight,
          maxWidth: route.maxWidth,
          maxLength: route.maxLength,
          minClearance: route.minClearance,
          roadCondition: { ...route.roadCondition },
        })) || [],
      amenities: boondock.amenities ? AmenityList.fromAmenities(boondock.amenities) : new AmenityList(),
      rating: boondock.getRating(),
      ratingCount: boondock.getRatingCount(),
    });
  }
  constructor(data?: ISearchableBoondocking) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: ISearchableBoondocking): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
